import React from 'react';
import CheckboxOnly from './CheckboxOnly';
import CheckboxItem from './CheckboxItem';
import CheckboxSelect from './CheckboxSelect';
import './checkbox.scss';

export const Checkbox = ({
    disabled = false,
    error = false,
    indeterminate = false,
    inputRef,
    label,
    name,
    onChange,
    onClick,
    required,
    size,
    value,
    variant = 'item',
}) => {

    return (<>
        {variant === 'checkbox' &&
            <CheckboxOnly
                disabled={disabled}
                error={error}
                indeterminate={indeterminate}
                label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                inputRef={inputRef}
                required={required}
                size={size}
                value={value}
            />
        }
        {variant === 'item' && 
            <CheckboxItem
                disabled={disabled}
                error={error}
                indeterminate={indeterminate}
                label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                inputRef={inputRef}
                required={required}
                size={size}
                value={value}
            />
        }
        {variant === 'select' &&
            <CheckboxSelect
                disabled={disabled}
                error={error}
                indeterminate={indeterminate}
                label={label}
                name={name}
                onClick={onClick}
                onChange={onChange}
                inputRef={inputRef}
                required={required}
                size={size}
                value={value}
            />
        }
    </>)
}